module.exports = __webpack_public_path__ + "img/SKMA_rules4.bd0fa6c3.png";